<template>
  <div class="rr">
    <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: #ede9e7" title="充值结果" left-arrow @click-left="goHome" />
    <div style="height: 46px"></div>
    <div class="rr-body">
      <div class="rr-icon" :class="stateClass">{{ stateIcon }}</div>
      <div class="rr-title">{{ stateText }}</div>
      <div class="rr-amount" v-if="amount">￥{{ amount }}</div>
      <div class="rr-order">订单号:{{ out_trade_no }}</div>
      <div class="rr-tip">{{ tip }}</div>
      <div class="rr-btns">
        <van-button type="info" block @click="goHome">返回首页</van-button>
        <van-button plain type="info" block style="margin-top: 12px" @click="goRecords">查看充值记录</van-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'rechargeResult',
  data() {
    return {
      out_trade_no: '',
      state: 0,
      amount: 0,
      tries: 0,
      timer: null,
    };
  },
  computed: {
    stateText() {
      return this.state == 2 ? '充值成功' : this.state == 3 ? '充值失败 / 已关闭' : '支付确认中...';
    },
    stateIcon() {
      return this.state == 2 ? '✓' : this.state == 3 ? '✕' : '…';
    },
    stateClass() {
      return this.state == 2 ? 'ok' : this.state == 3 ? 'fail' : 'pending';
    },
    tip() {
      return this.state == 2
        ? '金额已到账,可前往游戏'
        : this.state == 3
        ? '如您已付款请联系客服并提供订单号'
        : '到账以系统为准,通常 1-5 分钟;本页每 3 秒自动刷新';
    },
  },
  created() {
    this.out_trade_no = this.$route.query.out_trade_no || '';
    this.poll();
    this.timer = setInterval(this.poll, 3000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    poll() {
      let that = this;
      if (!that.out_trade_no) {
        return;
      }
      that.tries++;
      that.$apiFun
        .get('/api/recharge_status', { out_trade_no: that.out_trade_no })
        .then(res => {
          if (res.code == 200 && res.data) {
            that.state = res.data.state;
            that.amount = res.data.amount;
            if ((that.state == 2 || that.state == 3) && that.timer) {
              clearInterval(that.timer);
              that.timer = null;
            }
          }
          if (that.tries >= 40 && that.timer) {
            clearInterval(that.timer);
            that.timer = null;
          }
        })
        .catch(() => {});
    },
    goHome() {
      this.$router.push({ path: '/' });
    },
    goRecords() {
      this.$router.push({ path: '/transRecord' });
    },
  },
};
</script>
<style lang="scss" scoped>
.rr {
  min-height: 100vh;
  background: #edf1ff;
}
.rr-body {
  padding: 40px 24px;
  text-align: center;
}
.rr-icon {
  width: 1.6rem;
  height: 1.6rem;
  line-height: 1.6rem;
  border-radius: 50%;
  margin: 0 auto 20px;
  font-size: 0.9rem;
  color: #fff;
}
.rr-icon.ok {
  background: #07c160;
}
.rr-icon.fail {
  background: #ee0a24;
}
.rr-icon.pending {
  background: #ff976a;
}
.rr-title {
  font-size: 0.44rem;
  font-weight: 700;
  color: #333;
}
.rr-amount {
  font-size: 0.6rem;
  color: #cf866b;
  font-weight: 700;
  margin: 10px 0;
}
.rr-order {
  font-size: 0.28rem;
  color: #999;
  margin-top: 6px;
  word-break: break-all;
}
.rr-tip {
  font-size: 0.32rem;
  color: #a5a9b3;
  margin: 16px 0 30px;
}
.rr-btns {
  width: 86%;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/rechargeResult.vue